export const convertToCurrency = (
  baseValueCents: number,
  exchangeRate: number
) => {
  return Math.floor(baseValueCents * exchangeRate);
};
